<template>
  <div>
    <el-dialog
      title="新增模拟盘用户"
      :visible.sync="createVisible"
      width="30%"
      :before-close="handleClose"
    >
      <el-form :model="form" :rules="rules" ref="form">
        <!-- <el-form-item label="ID" :label-width="formLabelWidth" prop="id">
          <el-input v-model="form.id" autocomplete="off"></el-input>
        </el-form-item> -->
        <el-form-item label="邮箱" :label-width="formLabelWidth" prop="email">
          <el-input
            v-model="form.email"
            placeholder="请输入邮箱地址"
          ></el-input>
        </el-form-item>
        <el-form-item label="密码" :label-width="formLabelWidth" prop="pwd">
          <el-input
            v-model="form.pwd"
            type="password"
            show-password
            maxlength="22"
            autocomplete="new-password"
            placeholder="请输入密码"
          ></el-input>
          <div class="password-tip">
            密码须为8～22位，且同时包含数字、大写字母、小写字母和特殊字符，不能包含空格
          </div>
        </el-form-item>
        <el-form-item label="VIP等级" :label-width="formLabelWidth" prop="vipLevel">
          <el-select
            v-model="form.vipLevel"
            clearable
            placeholder="请选择VIP等级"
            style="width: 100%"
          >
            <el-option
              v-for="item in vipLevelOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialod('form')">取 消</el-button>
        <el-button type="primary" @click="add('form')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";

export default {
  data() {
    const validatePassword = (rule, value, callback) => {
      if (!value) {
        callback();
        return;
      }
      if (value.length < 8 || value.length > 22) {
        callback(new Error("密码长度需为8-22位"));
        return;
      }
      const hasRequiredChars =
        /\d/.test(value) &&
        /[A-Z]/.test(value) &&
        /[a-z]/.test(value) &&
        /[^A-Za-z0-9\s]/.test(value);
      if (/\s/.test(value) || !hasRequiredChars) {
        callback(
          new Error(
            "密码必须同时包含数字、大写字母、小写字母和特殊字符，且不能包含空格"
          )
        );
        return;
      }
      callback();
    };
    return {
      dialogFormVisible: false,
      formLabelWidth: "80px",
      form: {
        // id: "",
        email: "",
        pwd: "",
        vipLevel: "",
      },
      vipLevelOptions: Array.from({ length: 19 }, (_, level) => ({
        value: level,
        label: `VIP${level}`,
      })),
      rules: {
        email: [{ required: true, message: "请输入邮箱地址", trigger: "blur" }],
        pwd: [
          { required: true, message: "请输入密码", trigger: "blur" },
          { validator: validatePassword, trigger: "blur" },
        ],
      },
    };
  },
  computed: {
    ...mapState("userOldSimulation", ["createVisible"]),
  },
  methods: {
    ...mapMutations("userOldSimulation", ["setCreateVisible"]),
    ...mapActions("userOldSimulation", ["addUser"]),
    add(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.addUser({ ...this.form }).then((res) => {
            if (res.code == 0) {
              this.$message.success("添加成功");
              this.setCreateVisible(false);
              this.$emit("refresh");
              this.resetForm('form');
            } else {
              this.$message.error(res.msg);
            }
          });
        } else {
          this.$message.error("操作失败");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    closeDialod(formName) {
      this.resetForm(formName);
      this.setCreateVisible(false);
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          this.setCreateVisible(false);
          done();
        })
        .catch((_) => {});
    },
  },
};
</script>

<style lang="less" scoped>
.password-tip {
  margin-top: 6px;
  color: #909399;
  font-size: 12px;
  line-height: 18px;
}
</style>
